<template>
  <div>
    <Modal
      title="流程角色"
      :value="value"
      class-name="flowRoles"
      @on-visible-change="visibleChange">
      <p>流程用户ID: {{userInfo.abpUser.id}}</p>
      <p>所属主部门: {{master.name}}
        <a @click="edit = true">修改</a>
        <a @click="clear" v-if="master.id">删除</a>
      </p>
      <p>流程角色:
        <span v-for="role in userInfo.baseUserRole" :key="role.id">{{role.name}}</span>
      </p>
      <div slot="footer">
        <Button @click="cancel">取消</Button>
        <Button @click="synchronize" type="primary">同步</Button>
      </div>
    </Modal>
    <Modal
      title="设置主部门"
      v-model="edit">
      <span>请选择部门：</span>
      <Select v-model="master.orgGuid" style="width:280px">
        <Option v-for="item in apartmentList" :value="item.orgGuid" :key="item.id" >{{ item.name }}</Option>
      </Select>
      <div slot="footer">
        <Button @click="edit = false">取消</Button>
        <Button @click="submitEdit" type="primary">提交修改</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import userAjax from '@/lib/userAjax.ts'
import requestUrls from "@/lib/requestUrls"
export default {
  props: {
    value: Boolean
  },
  data() {
    return {
      userInfo: {
        abpUser: { id: '' },
        baseUserOrg: [],
        baseUserRole:[]
      },
      master: { orgGuid: '/', name: '/' },
      edit: false,
      apartmentList: []
    }
  },
  methods: {
    // 加载用户信息
    init() {
      userAjax.get(`/api/services/app/Synchronize/GetWecharUserByName`,{
        params: {
          name: this.$store.state.user.editUser.name
        }
      }).then(res => {
        if (res.data.result.length != 0) {
          this.userInfo = res.data.result[0]
          if (this.userInfo.baseUserOrg.length != 0) {
            let userOrg = this.userInfo.baseUserOrg.filter(item => {
              return item.isMaster === true
            })
            this.master = userOrg.length === 0 ? { orgGuid: '/', name: '/' } : userOrg[0]
            this.apartmentList = this.userInfo.baseUserOrg
          } else {
            this.master = { orgGuid: '/', name: '/' }
          }
        }
      })
    },
    visibleChange(value) {
      if(!value){
        this.$emit('input',value);
        this.master.orgGuid = ''
        this.apartmentList = []
      } else {
        this.init()
      }
    },
    // 提交修改
    submitEdit() {
      userAjax.put('/api/services/app/BaseUserOrg/UpdateUserOrganizationMaster', {
        abpUserId: this.userInfo.abpUser.id,
        masterOrgGuid: this.master.orgGuid
      }).then(() => {
        this.init()
        this.$Message.success('修改成功！')
        this.edit = false
      })
    },
    // 同步
    synchronize() {
      this.$Modal.confirm({
        title: '同步确认',
        content: '是否确定同步信息？',
        onOk: () => {
          userAjax.post(`/api/services/app/Synchronize/SynchronizeUserByUserId?AbpUserId=${this.userInfo.abpUser.id}`).then(res => {
            this.$Message.success('同步成功！')
            this.$emit('input',false);
          })
        },
        onCancel: () => {}
      })
    },
    cancel() {
      this.$emit('input',false);
    },
    clear() {
      this.$Modal.confirm({
        title: '删除提示',
        content: '<p>确定要删除该用户的主部门吗？</p>',
        onOk: () => {
          userAjax.delete('/api/services/app/BaseUserOrg/RemoveUserFromOrganizationUnit',{
            params: {
              AbpUserId: this.userInfo.abpUser.id,
              OrgGuid: this.master.orgGuid
            }
          }).then(res => {
            this.$Message.success('删除成功！')
            this.$emit('input',false);
          })
        },
        onCancel: () => {}
      });
    }
  }
}
</script>
<style lang="less" scoped>
.flowRoles p {
  margin: 10px 0;
  a {
    margin-left: 10px;
    text-decoration: underline;
  }
  span {
    line-height: 28px;
  }
  span + span::before {
    content: ' | '
  }
}
</style>
